import config from '../../config';
import { defaultHeaders } from './utils';

const getPendingFundReconciliation = async () => {
  const res = await fetch(
    `${config.pronvest.api.url}Admin/FundReconciliation/Pending`,
    {
      method: 'GET',
      headers: defaultHeaders(),
    }
  );

  if (res.ok) {
    return res.json();
  }

  return [];
};

const searchMasterFunds = async (term) => {
  const url = new URL(
    `${config.pronvest.api.url}Admin/FundReconciliation/SearchMasterFunds`
  );
  url.searchParams.set('term', term);

  const res = await fetch(url.toString(), {
    method: 'GET',
    headers: defaultHeaders(),
  });

  if (res.ok) {
    return res.json();
  }

  return [];
};

const confirmFundReconciliationMatch = async (
  fundReconciliationId,
  masterFundId
) => {
  const res = await fetch(
    `${config.pronvest.api.url}Admin/FundReconciliation/Confirm`,
    {
      method: 'POST',
      headers: {
        ...defaultHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ fundReconciliationId, masterFundId }),
    }
  );

  return res.ok;
};

const createMasterFundAndResolve = async ({
  fundReconciliationId,
  fundName,
  ticker,
  cusip,
  isin,
  assetClassId,
}) => {
  const res = await fetch(
    `${config.pronvest.api.url}Admin/FundReconciliation/CreateMasterFund`,
    {
      method: 'POST',
      headers: {
        ...defaultHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fundReconciliationId,
        fundName,
        ticker,
        cusip,
        isin,
        assetClassId,
      }),
    }
  );

  if (res.ok) {
    return res.json();
  }

  return null;
};

export {
  getPendingFundReconciliation,
  searchMasterFunds,
  confirmFundReconciliationMatch,
  createMasterFundAndResolve,
};
